// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import axios from 'axios';

Vue.config.productionTip = false

// 예: main.js 또는 App.vue에서 초기화 시
const user = sessionStorage.getItem('user');
const token = sessionStorage.getItem('token');
if (user) {
  const parsedUser = JSON.parse(user); // 여기서 JSON으로 파싱해야 token 접근 가능
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
  store.commit('SET_USER', parsedUser); // Vuex에 다시 복원
}


// ✅ Toast 플러그인 등록
Vue.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
